import { NSB_MENSAJE_ADD, NSB_MENSAJE_REM } from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  mensaje: "",
  variant: "success",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case NSB_MENSAJE_ADD:
      let m = get(action, "payload");
      return { ...state, mensaje: m.mensaje, variant: m.variant };
    case NSB_MENSAJE_REM:
      return { ...state, mensaje: "", variant: "success" };
    default:
      return { ...state };
  }
}
